import React, { useState } from 'react';
import { Container, Typography, Box, Button, Modal, Paper } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import Layout from '../components/Layout/Layout';
import VehicleTable from '../components/Vehicles/VehicleTable';
import VehicleForm from '../components/Vehicles/VehicleForm';
import VehicleHistoryModal from '../components/Vehicles/VehicleHistoryModal';

const VehiclesPage = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [historyVehicleId, setHistoryVehicleId] = useState(null);
  const queryClient = useQueryClient();

  const handleEdit = (vehicle) => {
    setEditingVehicle(vehicle);
    setOpenForm(true);
  };

  const handleFormSuccess = () => {
    setOpenForm(false);
    setEditingVehicle(null);
    queryClient.invalidateQueries(['vehicles']);
  };

  return (
    <Layout>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Typography variant="h4" fontWeight={600}>Vehicles & Equipment</Typography>
            <Typography variant="body1" color="textSecondary">
              Manage fleet vehicles and track installed navigation equipment
            </Typography>
          </Box>
          <Button 
            variant="contained" 
            startIcon={<AddIcon />} 
            onClick={() => { 
              setEditingVehicle(null); 
              setOpenForm(true); 
            }}
          >
            Add Vehicle
          </Button>
        </Box>

        <VehicleTable 
          onViewHistory={(id) => setHistoryVehicleId(id)} 
          onEdit={handleEdit}
        />

        <Modal 
          open={openForm} 
          onClose={() => { 
            setOpenForm(false); 
            setEditingVehicle(null); 
          }}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Paper sx={{ width: 600, maxWidth: '90%', p: 3, maxHeight: '90vh', overflow: 'auto' }}>
            <VehicleForm
              open={openForm}
              onClose={() => { 
                setOpenForm(false); 
                setEditingVehicle(null); 
              }}
              vehicle={editingVehicle}
              onSuccess={handleFormSuccess}
            />
          </Paper>
        </Modal>

        <VehicleHistoryModal 
          open={!!historyVehicleId} 
          vehicleId={historyVehicleId} 
          onClose={() => setHistoryVehicleId(null)} 
        />
      </Container>
    </Layout>
  );
};

export default VehiclesPage;